export enum PlansStatusEnum {
  NOW_SELLING = "Now selling",
  PREPARING_TO_LAUNCH = "Preparing to launch",
  PLANNING = "Planning",
}
